import { Row, Col, Button } from "react-bootstrap";
import { ArrowLeft, Eye, Bookmark, UserCheck, Download } from "lucide-react";
import TimelineItem from "./TimelineItem";
import InfoCol from "./InfoCol";
import Stat from "./Stats";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";const TenderHeader = ({ tender, timelineItems, enableResultColors }) => {
  const navigate = useNavigate();
const { role } = useAuth();
const isAdmin = role === "admin";
  return (
    <>
      <Button
        variant="link"
        className="d-flex align-items-center gap-2 mb-3 text-decoration-none"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={22} className="arrow-left-slide"/>
      </Button>
    <div className="bg-white rounded-4 shadow-sm p-4">
    

      <Row className="gy-4">
        {/* LEFT */}
        <Col lg={7}>
             <div className="d-flex align-items-center gap-3 mb-2">
  <h3 className="fw-bold mb-0">{tender.title}</h3>

  <span className="tender-status-badge-award">
    <span className="tender-badge-dot award-dot" />
    {tender.resultStatus}
  </span>
</div>

          <Row className="gy-2 mt-4">
            <InfoCol label="Department" value={tender.department} />
            <InfoCol label="Ministry" value={tender.ministry} />
            <InfoCol label="Location" value={tender.location} />
            <InfoCol label="Tender Value" value={tender.tenderValue} />
          </Row>
        </Col>

        {/* RIGHT */}
        <Col lg={5} className="d-flex flex-column">
          <div className="position-relative mb-4 timeline-wrapper">
            <div className="timeline-line" />
            <Row className="text-center g-0">
             {timelineItems.map((item, index) => {
  let variant = "";

  if (enableResultColors) {
    if (item.label === "Technical Opening") {
      variant = "blue";
    }
    if (item.label === "Award Date") {
      variant = "yellow";
    }
  }

  return (
    <TimelineItem
      key={index}
      {...item}
      variant={variant}
      enableVariant={enableResultColors}
    />
  );
})}

            </Row>
          </div>
        </Col>
      </Row>

   <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-md-end gap-3 gap-md-4 mt-4 stats-actions-wrapper">

        <div className="d-flex gap-4">
          <Stat icon={Eye} value={tender.stats.views} />
          <Stat icon={Bookmark} value={tender.stats.interested} />
          <Stat icon={UserCheck} value={tender.stats.applies} label="Applied" />
        </div>

     
  {!isAdmin && (
  <Button className="download-view-btn rounded-pill px-4">
    <Download size={16} className="me-2" />
    Download
  </Button>
)}
      </div>
      
    </div>
    
    </>
  );
};

export default TenderHeader;
